import { useSelector } from "react-redux";
import { selectIsLoggedIn } from "../../redux/selectors";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
